<script setup lang="ts">
import { RouterView } from 'vue-router';
import { Toaster } from '@/components/ui/sonner'
import TrackListExportHost from '@/components/TrackListExportHost.vue';

</script>

<template>
  <Toaster position="bottom-right" :duration="5000" :visibleToasts="3"  :close-button="true"/>
  <!--
    Headless. Must stay OUTSIDE <RouterView>: an export is started from an
    inspector and finishes minutes later, by which time the user has usually
    navigated away. Anything mounted inside the router view unmounts on
    navigation and takes its Echo subscription with it, so the "ready" toast
    would never fire.
  -->
  <TrackListExportHost />
  <!-- No app-wide TooltipProvider: every Tooltip mounts its own provider (see ui/tooltip/Tooltip.vue). -->
  <RouterView></RouterView>
</template>
